import React from "react";
import { Container } from "../container";

export const Title: React.FC<{ title: string }> = ({ title, ...props }) => {
  return (
    <Container {...props} className="mt-5 grid grid-cols-4 gap-16">
      <div className="hidden lg:col-span-1 lg:flex"> </div>
      <div className="col-span-4 lg:col-span-2">
        <h2 className="text-lg font-bold lg:text-2xl">{title}</h2>
      </div>
    </Container>
  );
};
